'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _isFetchingReducer = require('./is-fetching-reducer');

var _isFetchingReducer2 = _interopRequireDefault(_isFetchingReducer);

var _userFollowsReducer = require('./user-follows-reducer');

var _userFollowsReducer2 = _interopRequireDefault(_userFollowsReducer);

var _pendingUserFollowsReducer = require('./pending-user-follows-reducer');

var _pendingUserFollowsReducer2 = _interopRequireDefault(_pendingUserFollowsReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var followReducer = (0, _redux.combineReducers)({
  isFetching: _isFetchingReducer2.default,
  userFollows: _userFollowsReducer2.default,
  pendingUserFollows: _pendingUserFollowsReducer2.default
});

exports.default = followReducer;